module.exports = __webpack_public_path__ + "media/PAG88-08.404ceb45.mp3";